<script setup>
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const emit = defineEmits(['open-create-modal']);
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col h-full w-full bg-n-surface-1">
    <!-- Top Header -->
    <header
      class="flex h-16 w-full items-center justify-between border-b border-n-weak px-6"
    >
      <h1 class="text-xl font-bold text-n-slate-12">Funis</h1>
      <button
        type="button"
        class="flex items-center gap-1.5 rounded-xl bg-n-brand px-4 py-2 text-xs font-bold text-[#1c1c1c] shadow hover:brightness-95 transition-all cursor-pointer"
        @click="emit('open-create-modal')"
      >
        <Icon icon="i-lucide-plus" class="size-4" />
        <span>Adicionar Funil</span>
      </button>
    </header>

    <!-- Empty State Content -->
    <main
      class="flex flex-1 flex-col items-center justify-center p-6 text-center"
    >
      <div class="flex flex-col items-center max-w-md">
        <!-- Icon Container -->
        <div
          class="flex size-14 items-center justify-center rounded-2xl bg-n-solid-3 text-n-slate-12 mb-6 shadow-sm border border-n-weak"
        >
          <Icon icon="i-lucide-align-justify" class="size-7 opacity-80" />
        </div>

        <h2 class="text-lg font-bold text-n-slate-12 mb-2">
          Nenhum funil ainda
        </h2>
        <p class="text-xs text-n-slate-10 mb-6 leading-relaxed">
          Comece criando seu primeiro funil para organizar e gerenciar seu
          pipeline
        </p>

        <button
          type="button"
          class="flex items-center gap-2 rounded-xl bg-n-brand px-5 py-2.5 text-xs font-extrabold text-[#1c1c1c] shadow-md hover:brightness-95 transition-all cursor-pointer"
          @click="emit('open-create-modal')"
        >
          <Icon icon="i-lucide-plus" class="size-4" />
          <span>Criar seu primeiro funil</span>
        </button>
      </div>
    </main>
  </div>
</template>
